import { BetState } from '@bpos/v1/my-bets';
import { OfferSource } from '@cds';
import { Parameter } from '@cds/betting-offer';
import { MyBetsOption } from '@cds/my-bets';

import { BetBuilderLegState } from '../../my-bets-base/models/my-bets-viewmodels';

export interface VisualizationTracking {
    isTrackingEnabled: boolean;
    visualizationType: VisualizationType;
}

export interface PeriodDictionary {
    // period value (e.g. 'FirstHalf') to period ID (e.g. '1') currently obtaining this information from what is configured in DynaCon
    // eg: ["Team.scoreDetailed.player1.255|RegularTime", "Team.corners.player1.1|FirstHalf", "Team.corners.player2.3|SecondHalf", ] -> { "RegularTime": "255", "FirstHalf": "1", "SecondHalf": "3" }
    [periodValue: string]: string;
}

export interface MarketStatInfo {
    marketId: number;
    marketStats: string[];
    periodIdsMap?: PeriodDictionary;
    playerIds: number[];
    templateId?: number;
    source: OfferSource;
    marketType: string;
    parameters: Parameter[];
    options: MyBetsOption[];
}

export interface PlayerInfo {
    playerName: string;
    playerId?: number;
}

export interface PlayerStatInfo {
    player1CurrStat: number;
    player2CurrStat: number;
    targetStat: number[];
    optionName: string;
    player: PlayerInfo;
}

export interface BetMarketInfo {
    marketId: number;
    marketName: string;
    optionId: number;
    optionName: string;
    state: BetState | BetBuilderLegState;
}

export const enum VisualizationType {
    TargetVisualization = 'targetVisualization',
    H2hVisualization = 'h2HVisualization',
    TextualVisualization = 'textualVisualization',
    NoVisualization = 'noVisualization',
}

export const enum VisualizationConstants {
    Player1 = 'player1',
    Player2 = 'player2',
    HomePlayer = 'homePlayer',
    AwayPlayer = 'awayPlayer',
    ZeroState = 'zero state',
    InProgressState = 'inprogress state',
    Team = 'Team',
}

export const enum VisualizationBetState {
    Placed = 'Placed',
    Open = 'Open',
    Won = 'Won',
    Lost = 'Lost',
    Cancelled = 'Cancelled',
    WithHeld = 'WithHeld',
    Winning = 'Winning',
    Losing = 'Losing',
}

export const betStateMapping = {
    [BetState.Open]: VisualizationBetState.Open,
    [BetState.Placed]: VisualizationBetState.Open,
    [BetState.Won]: VisualizationBetState.Won,
    [BetState.Lost]: VisualizationBetState.Lost,
    [BetState.Canceled]: VisualizationBetState.Cancelled,
    [BetState.WithHeld]: VisualizationBetState.WithHeld,
    [BetBuilderLegState.Open]: VisualizationBetState.Open,
    [BetBuilderLegState.Won]: VisualizationBetState.Won,
    [BetBuilderLegState.Lost]: VisualizationBetState.Lost,
    [BetBuilderLegState.Cancelled]: VisualizationBetState.Cancelled,
};
